import { JetView } from 'webix-jet';
import { devConfig, countries, providersCasino, subprovidersCasino, gamesCasino, profile } from 'config/config';

/**
 * Class representing the FilterCasinoReportView.
 * @extends JetView
 */
export default class FilterCasinoReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._;
        var typeReport = '';

        // Delayed execution to retrieve the report type from the URL
        webix.ready(function () {
            webix.delay(
                function () {
                    typeReport = window.location.href.split('/')[5];
                },
                '',
                '',
                500,
            );
        });

        // Left section of the form containing filters
        const left = {
            margin: 5,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'text',
                            minWidth: 200,
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            value:
                                moment().subtract(0, 'days').format('YYYY-MM-DD') +
                                ' - ' +
                                moment().format('YYYY-MM-DD'),
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                        },
                        {
                            view: 'datepicker',
                            name: 'Date',
                            id: 'Date',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: moment().format('YYYY-MM-DD'),
                            format: '%d %M %Y',
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(),
                                },
                            },
                        },
                        {
                            view: 'text',
                            name: 'PlayerId',
                            type: 'number',
                            minWidth: 200,
                            label: "<span class='icon-user'></span>" + _('ID Usuario'),
                            hidden: !devConfig.getPermAction('filterByUser', 'Add'),
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            placeholder: _('ID Usuario'),
                            invalidMessage: _('ID Usuario is required'),
                        },
                        {
                            view: 'text',
                            name: 'Id',
                            type: 'number',
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _('Campo ID'),
                            labelPosition: 'top',
                            placeholder: _('Campo ID'),
                        },
                        {
                            view: 'richselect',
                            name: 'CountrySelect',
                            id: 'CountrySelect',
                            minWidth: 200,
                            localId: 'regions:combo',
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    template: function (obj) {
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries,
                                },
                            },
                            hidden: devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'),
                            css: 'prm-filterByCountry',
                        },
                        {
                            view: 'richselect',
                            name: 'CountrySelect2',
                            minWidth: 200,
                            localId: 'regions:combo',
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: profile.Settings.ReportCountry,
                            readonly: true,
                            options: {
                                body: {
                                    template: function (obj) {
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries,
                                },
                            },
                            hidden: !devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'),
                            css: 'prm-filterByCountry',
                            css: 'country-hide',
                        },
                    ],
                },
            ],
        };

        // Additional left section for provider and product filters
        const left3 = {
            margin: 5,
            id: 'a3',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a3',
                    cols: [
                        {
                            view: 'combo',
                            name: 'ProviderId',
                            minWidth: 200,
                            label: _('Proveedor'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        var vthis = this;
                                        if (text.length > 2) {
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/ProvidersCasinoSelect',
                                                    '{"Filter":"' + text + '"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message('Error! ');
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text);
                                                            if (!resp.HasError) {
                                                                vthis.parse(resp.Data);
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                        {
                            view: 'combo',
                            name: 'SubProviderId',
                            minWidth: 200,
                            label: _('Sub Proveedor'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        var vthis = this;
                                        if (text.length > 2) {
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/SubProvidersCasinoSelect',
                                                    '{"Filter":"' + text + '"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message('Error! ');
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text);
                                                            if (!resp.HasError) {
                                                                vthis.parse(resp.Data);
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                        {
                            view: 'combo',
                            name: 'ProductId',
                            minWidth: 200,
                            label: _('Producto'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        var vthis = this;
                                        if (text.length > 2) {
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/GamesCasinoSelect',
                                                    '{"Filter":"' + text + '"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message('Error! ');
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text);
                                                            if (!resp.HasError) {
                                                                vthis.parse(resp.Data);
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                        {
                            view: 'richselect',
                            name: 'Type',
                            minWidth: 200,
                            localId: 'provider:combo',
                            label: _('Tipo'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: '', value: _('Todos') },
                                { id: 'N', value: _('Normal') },
                                { id: 'FS', value: _('FreeSpin') },
                                { id: 'FC', value: _('FreeCash') },
                            ],
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a3',
                    cols: [
                        {
                            view: 'text',
                            name: 'ValueMinimum',
                            type: 'number',
                            minWidth: 200,
                            label: "<span class='icon-cash'></span>" + _('Valor Mínimo'),
                            labelPosition: 'top',
                            placeholder: _('Valor Mínimo'),
                        },
                        {
                            view: 'text',
                            name: 'ValueMaximum',
                            type: 'number',
                            minWidth: 200,
                            label: "<span class='icon-cash'></span>" + _('Valor Máximo'),
                            labelPosition: 'top',
                            placeholder: _('Valor Máximo'),
                        },
                        {
                            view: 'richselect',
                            name: 'Categorie',
                            minWidth: 200,
                            id: 'Categorie',
                            localId: 'categorie:combo',
                            label: "<span class='icon-category'></span>" + _('Categorías'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [],
                        },
                        { gravity: 1, id: 'grav3', minWidth: 200 },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a3',
                    cols: [
                        {
                            view: 'checkbox',
                            label: _('Resumen por Proveedor'),
                            labelPosition: 'top',
                            name: 'IsDetails',
                            id: 'IsDetails',
                            value: 1,
                            minWidth: 200,
                            height: 80,
                        },
                    ],
                },
            ],
        };

        // Sorting and identifier section
        const left2 = {
            margin: 5,
            id: 'b2',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'b2',
                    cols: [
                        {
                            view: 'combo',
                            name: 'Sort',
                            label: _('Ordenar por'),
                            labelPosition: 'top',
                            minWidth: 200,
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: '1', value: _('Fecha') },
                                { id: '2', value: _('Usuario') },
                                { id: '3', value: _('Apuestas') },
                                { id: '4', value: _('Premios') },
                            ],
                            value: '1',
                        },
                        {
                            view: 'combo',
                            name: 'Dir',
                            label: _('Orden'),
                            labelPosition: 'top',
                            minWidth: 200,
                            options: [
                                { id: '0', value: _('Ascendente') },
                                { id: '1', value: _('Descendente') },
                            ],
                            value: '0',
                        },
                        {
                            view: 'text',
                            name: 'Identifier',
                            label: _('Identificador'),
                            labelPosition: 'top',
                            minWidth: 200,
                            placeholder: _('Identificador'),
                        },
                        { gravity: 1, id: 'grav2', minWidth: 200 },
                    ],
                },
            ],
        };

        // Upper section containing the left filters
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left],
                },
                {
                    margin: 10,
                    cols: [left3],
                },
            ],
        };

        // Buttons for clearing and consulting the report
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Limpiar'),
                    width: 100,
                    click: () => {
                        $$('myForm').setValues($$('myForm').getCleanValues());
                        $$('CountrySelect').setValue($$('myForm').getCleanValues().CountrySelect);
                        $$('DateStart').setValue('');
                        $$('DateEnd').setValue('');
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'),
                    type: 'form',
                    width: 110,
                    id: 'consultDesk',
                    click: () => {
                        const filterdata = this.getRoot().getValues();
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry;
                        }
                        delete filterdata['CountrySelect2'];
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date'];
                            delete filterdata['Date2'];
                        } else {
                            if (true) {
                                delete filterdata['DateStart'];
                                delete filterdata['DateEnd'];
                            }
                        }
                        filterdata.TypeReport = typeReport;
                        this.app.callEvent('casinoReport:filter', [filterdata]);
                        $$('b5').collapse();
                        $$('a5').scrollTo(100, 0);
                    },
                },
            ],
        };

        // Buttons for the second form
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button',
                    value: _('Limpiar'),
                    click: () => {
                        $$('myForm2').setValues($$('myForm2').getCleanValues());
                        $$('CountrySelect').setValue($$('myForm2').getCleanValues().CountrySelect);
                        $$('DateStart').setValue('');
                        $$('DateEnd').setValue('');
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'),
                    type: 'form',
                    click: () => {
                        const filterdata = $$('myForm2').getValues();
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry;
                        }
                        delete filterdata['CountrySelect2'];
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date'];
                            delete filterdata['Date2'];
                        } else {
                            if (true) {
                                delete filterdata['DateStart'];
                                delete filterdata['DateEnd'];
                            }
                        }
                        filterdata.TypeReport = typeReport;
                        this.app.callEvent('casinoReport:filter', [filterdata]);
                        $$('b5').collapse();
                        $$('a5').scrollTo(100, 0);
                    },
                },
            ],
        };

        // Accordion section for filters
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'),
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, left2, buttons],
                            },
                        },
                    ],
                },
            ],
        };

        // Scrollable accordion section
        const accordion_section3 = {
            view: 'scrollview',
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section, left2],
            },
        };

        // Popup window for filters
        const filterPopup = webix.ui({
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' },
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide();
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3, buttons2],
                rules: {
                    fname: webix.rules.isNotEmpty,
                },
            },
        });

        // Return the main form configuration
        return {
            view: 'form',
            id: 'myForm',
            type: 'clean',
            rows: [screen.width > 500 && screen.height > 500 ? accordion_section2 : { height: 1, width: 0 }],
            rules: {
                fname: webix.rules.isNotEmpty,
            },
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        $$('b2').hide();

        // Event handler for the details checkbox
        $$('IsDetails').attachEvent('onChange', function (newv, oldv) {
            if ($$('IsDetails').getValue() == '1') {
                $$('b2').hide();
            } else {
                $$('b2').show();
            }
        });

        const lang = this.app.getService('locale').getLang();

        // Event handler for datepicker rendering
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang);
        });

        // Additional setup on webix ready
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav2').hide();
                $$('grav3').hide();
            }
            if (profile.typeDate !== 2) {
                $$('Date').hide();
                $$('Datepicker').show();
            } else {
                if (true) {
                    $$('Date').show();
                    $$('Datepicker').hide();
                }
            }
            var typeReport = '';
            webix.ready(function () {
                webix.delay(
                    function () {
                        typeReport = window.location.href.split('/')[5];
                        const params = {
                            typeReport: typeReport,
                        };
                        webix
                            .ajax()
                            .headers({
                                'Content-type': 'application/json',
                            })
                            .post(devConfig.geturlApi() + 'Select/GetInformationCategories', params, {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.message(_('Error! '));
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var data = JSON.parse(text);
                                    var options = $$('Categorie').getList();
                                    options.clearAll();
                                    options.parse(data.Data);
                                },
                            });
                    },
                    '',
                    '',
                    500,
                );
            });
        });
    }
}

// FILE DOCUMENTED
